// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"1f7d0adc","598":"e5421345","703":"192e1cc0","787":"ba43c621"}[chunkId] + ".chunk.js";
};